<template>
	<TableFilter :scheme-type="enumDef.filterSchemeType.BuyerMarketSoundingDecisions"
				 :filter-refs="$refs"
				 @apply-filter="applyFilter"
	>
		<!-- debtor -->
		<div class="filter_item filter_item_s">
			<div class="filter_head">{{ $t("common.debtor") }}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="debtorName"
						ref="filter_debtorName"
			></TextFilter>
			<IndustryFilter :label-text="$t('common.industry')"
							column-name="debtorIndustryNaceCode"
							ref="filter_debtorIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="$t('common.country')"
						   :company-type="enumDef.companyType.DebtorCompany"
						   column-name="debtorCountry"
						   ref="filter_debtorCountry">
			</CountryFilter>
			<EnumFilter :label-text="$t('marketSoundingDecision.filter.myEvaluation')"
						column-name="investorDebtorConfigStatus"
						:enum-def="enumDef.InvestorSellerDebtorConfigStatus"
						ref="filter_investorDebtorConfigStatus"
			></EnumFilter>
		</div>
		<!-- seller -->
		<div class="filter_item filter_item_s">
			<div class="filter_head">{{ $t("common.seller") }}</div>
			<TextFilter :label-text="$t('common.name')"
						column-name="sellerName"
						ref="filter_sellerName"
			></TextFilter>
			<IndustryFilter :label-text="$t('common.industry')"
							column-name="sellerIndustryNaceCode"
							ref="filter_sellerIndustry"
			></IndustryFilter>
			<CountryFilter :label-text="$t('common.country')"
						   column-name="sellerCountry"
						   ref="filter_sellerCountry">
			</CountryFilter>
			<TextFilter :label-text="$t('common.partner')"
						column-name="partnerName"
						ref="filter_partnerName"
			></TextFilter>
			<EnumFilter :label-text="$t('marketSoundingDecision.filter.myEvaluation')"
						column-name="investorSellerConfigStatus"
						:enum-def="enumDef.InvestorSellerDebtorConfigStatus"
						ref="filter_investorSellerConfigStatus"
			></EnumFilter>
		</div>
		<!-- data base 12Month -->
		<div class="filter_item filter_item_xl">
			<div class="filter_head">{{ $t("investor.exchange.filter.riskAnalysis.groupTitle") }}</div>
			<DateFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.dsrExistsSince')"
						column-name="dsrExistsSince"
						ref="filter_dsrExistsSince"
			></DateFilter>
			<FromToFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.all')"
						  column-name="dsrAssessmentTotalCases"
						  field-type="I"
						  ref="filter_dsrAssessmentTotalCases"
			></FromToFilter>
			<FromToFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.soldAmount')"
						  column-name="dsrAssessmentSoldAmount"
						  ref="filter_dsrAssessmentSoldAmount"
			></FromToFilter>
			<FromToFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.fullyPaid')"
						  column-name="dsrAssessmentFullyPaidCases"
						  field-type="I"
						  ref="filter_dsrAssessmentFullyPaidCases"
			></FromToFilter>
		</div>
		<!-- receivable detail -->
		<div class="filter_item filter_item_l">
			<div class="filter_head">{{ $t("marketSoundingDecision.table.header.opportunityDetails") }}</div>
			<EnumFilter :label-text="$t('common.type')"
						column-name="receivableType"
						:enum-def="enumDef.receivableType"
						ref="filter_receivableType"
			></EnumFilter>
			<FromToFilter :label-text="$t('common.amount')"
						  column-name="prospectiveReceivableAmount"
						  ref="filter_prospectiveReceivableAmount"
			></FromToFilter>
			<DateFilter :label-text="$t('common.dueDate')"
						column-name="prospectiveReceivableDueDate"
						ref="filter_prospectiveReceivableDueDate"
			></DateFilter>
			<DateFilter :label-text="$t('common.invoiceDate')"
						column-name="prospectiveReceivableInvoiceDate"
						ref="filter_prospectiveReceivableInvoiceDate"
			></DateFilter>
			<FromToFilter :label-text="$t('common.paymentTerm')"
						  column-name="prospectiveReceivablePaymentTerm"
						  field-type="L"
						  ref="filter_prospectiveReceivablePaymentTerm"
			></FromToFilter>
			<CountryFilter :label-text="$t('common.applicableLaw')"
						   :companyType="enumDef.companyType.DebtorCompany"
						   column-name="applicableLaw"
						   ref="filter_applicableLaw"
			></CountryFilter>
			<EnumFilter :label-text="$t('common.assignmentType')"
						column-name="postTrade"
						:enum-def="enumDef.postTradeType"
						:exclude="(value) => enumDef.postTradeType.excludeForMarketSounding(value)"
						ref="filter_postTrade"
			></EnumFilter>
			<TextFilter :label-text="$t('common.contractNumber')"
						column-name="prospectiveInstallmentContractNumber"
						ref="filter_prospectiveInstallmentContractNumber"
			></TextFilter>
		</div>
	</TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

import EnumFilter from "@/components/newFilter/EnumFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import IndustryFilter from "@/components/newFilter/IndustryFilter.vue";
import CountryFilter from "@/components/newFilter/CountryFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import TableFilter from "@/components/newFilter/TableFilter";
import BooleanFilter from "@/components/newFilter/BooleanFilter";

export default {
	props: {
		ratingConfig: Object
	},
	components: {
		BooleanFilter,
		TableFilter,
		DateFilter,
		IndustryFilter,
		TextFilter,
		EnumFilter,
		FromToFilter,
		CountryFilter,
	},
	data() {
		return {
			enumDef: enumDef,
		};
	},
	methods: {
		applyFilter(filters) {
			this.$emit("apply-filter", filters);
		}
	},
};
</script>